<template>
  <base-section light>
    <div class="row justify-content-center my-5">
      <div class="col-md-5">
        <template v-if="!registerBorrowerOnly && !registerInvestorOnly">
          <form @submit.prevent="submit">
            <base-card class="mb-0">
              <base-header class="card-title text-center" no-bottom-margin>Select your account type</base-header>
              <div class="row justify-content-center mt-4">
                <div class="col text-right">
                  <base-button :disabled="processing" exact primary @click="select('investor')">
                    I want to invest
                  </base-button>
                </div>
                <div class="col text-left">
                  <base-button :disabled="processing" exact primary @click="select('borrower')">
                    I'd like to borrow
                  </base-button>
                </div>
              </div>
            </base-card>
          </form>
        </template>
        <template v-else>
          <base-loader />
        </template>
      </div>
    </div>
  </base-section>
</template>

<script>
import { mapActions } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  data: () => ({
    processing: false,
    registerBorrowerOnly: false,
    registerInvestorOnly: false
  }),

  created () {
    this.registerBorrowerOnly = this.$app.config('register_borrower_only') || false
    this.registerInvestorOnly = this.$app.config('register_investor_only') || false

    if (this.registerBorrowerOnly) {
      this.select('borrower')
    } else if (this.registerInvestorOnly) {
      this.select('investor')
    }
  },

  methods: {
    async select (role) {
      this.processing = true

      await this.assignRole(role)
      await this.setMeta([
        {
          key: 'registrationComplete',
          value: false
        },
        {
          key: 'registrationStep',
          value: 'details'
        }
      ])

      this.$router.push({ name: 'register.details' })
    },

    ...mapActions({
      assignRole: 'core/auth/assign-role',
      setMeta: 'core/auth/set-meta'
    })
  }
}
</script>
